import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs } from "../../../../../components";
import { useAuth } from "../../../../../context/AuthContext";
import { DepositBet, FirstDeposit, NewRegister } from "./components";

const DownlineDetailReport = ({ startAt = null, endAt = null }) => {
  const { t } = useTranslation();
  const { rebateMode } = useAuth();
  const [activeTab, setActiveTab] = useState("register");
  const tabItems = [
    {
      key: "register",
      title: t("downlineReport.tab.register"),
      component: <NewRegister startAt={startAt} endAt={endAt} rebateMode={rebateMode} />,
    },
    {
      key: "firstDeposit",
      title: t("downlineReport.tab.firstDeposit"),
      component: <FirstDeposit startAt={startAt} endAt={endAt} rebateMode={rebateMode} />,
    },
    {
      key: "depositBet",
      title: t("downlineReport.tab.depositBet"),
      component: <DepositBet startAt={startAt} endAt={endAt} rebateMode={rebateMode} />,
    },
  ];

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div>
      <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={tabItems} />
    </div>
  );
};

export default DownlineDetailReport;
